<template>
    <div v-for="merch in list" class="w-full flex surface-50  
        flex-column xl:flex-row lg:flex-row md:flex-row sm:flex-row
        m-0 mb-2 xl:mb-3 lg:mb-3 md:mb-3
        p-3 xl:p-4 lg:p-4 md:p-4
        gap-2 xl:gap-4 lg:gap-3 md:gap-3
        border-round-2xl 
        text-left relative">

        <div class="flex flex-1 flex-row gap-2">
            <div class="flex flex-1 flex-column">
                <!--ID-->
                <span class="flex text-600 mb-2">
                    <span class="text-sm flex flex-row" @click="copy(merch.id)">
                        <span class="flex ">{{ get_short_id(merch.id) }}</span>
                        <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                    </span>
                </span>

                <!--NAME-->
                <div class="flex flex-row w-2 mb-2">
                    <span class="flex text-700 text-xl font-medium white-space-nowrap">
                        {{ merch.name }}
                    </span>
                </div>

                <!--STATUS-->
                <div class="flex flex-row mb-2 gap-1">
                    <span class="flex text-white font-medium text-xs p-1 border-round-md"
                        :class="(merch.active) ? 'bg-green-400' : 'bg-yellow-600'">
                        {{ (merch.active) ? 'Активен' : 'Не активен' }}
                    </span>
                    <div v-if="merch.online != undefined" class="flex flex-row">
                        <span class="flex text-white font-medium text-xs p-1 border-round-md"
                            :class="(merch.online) ? 'bg-green-400' : 'bg-yellow-600'">
                            {{ (merch.online) ? 'В линии' : 'Не в линии' }}
                        </span>
                    </div>
                </div>

                <!--USER ID-->
                <span class="flex text-600 mb-2">
                    <span class="text-sm flex flex-row">
                        <span class="flex text-primary cursor-pointer" @click="goToUser(merch.user_id)">{{ get_short_id(merch.user_id) }}</span>
                        <span class="hidden xl:flex lg:flex md:flex pi pi-copy ml-2 text-500 text-xs cursor-pointer" @click="copy(merch.user_id)"></span>
                    </span>
                </span>

                <!--TG-->
                <span v-if="merch.username" class="text-sm flex text-primary flex-row mb-2 cursor-pointer" @click="toTg(merch.username)">
                    <span class="flex white-space-nowrap">{{ merch.username }}</span>
                    <i class="pi pi-telegram ml-2 text-xs" />
                </span>
            </div>
            
            <!--DEPOSIT-->
            <div class="flex flex-1 flex-column w-2 mr-2 mb-2 xl:mb-0 lg:mb-0 md:md-0">
                <span class="flex text-600 mb-2">
                    <span class="text-sm flex flex-row">
                        <span class="flex ">
                            Депозит 
                            <span v-if="isUserInGroup('admin')" class="ml-1">[{{ merch.priority}}]</span> 
                        </span>
                    </span>
                </span>
                <div class="flex flex-row w-2 mb-2">
                    <span v-if="merch.deposit" class="flex text-700 text-xl font-medium white-space-nowrap">
                        {{ get_format_amount(merch.deposit, 'usdt') }}
                    </span>
                </div>
                <div class="flex flex-row mb-2">
                    <span class="flex text-white font-medium text-xs p-1 border-round-md"
                        :class="(merch.trusted) ? 'bg-green-400' : 'surface-400'">
                        {{ (merch.trusted) ? 'Доверен' : 'Не доверен' }}
                    </span>
                </div>
            </div>
        </div>
        
        <!--TIME-->
        <div class="flex flex-1 flex-row">
            <div class="flex flex-column mr-3">
                <span class="text-sm text-600 mb-2 block">Время работы:</span>
                <span class="flex text-700 font-medium white-space-nowrap mb-2
                    text-sm xl:text-xl lg:text-xl md:text-lg">
                    {{ get_msk_time(merch.active_from) }} – {{ get_msk_time(merch.active_to) }} (МСК)
                </span>
                <span class="text-md text-600 block mb-2 text-sm">{{ get_local_time(merch.active_from) }} – {{ get_local_time(merch.active_to) }} (Bali)</span>
            </div>
        </div>

        <!--BTNS-->
        <div class="flex flex-row">
            <div class="flex flex-row xl:flex-column lg:flex-column md:flex-column
                xl:mb-0 lg:mb-0 md:md-0">
                <div class="flex flex-row mb-2 mr-3">
                    <Button label="Подробно" @click='detail_page(merch.id, false)' size="small" class="flex border-round-md mr-2 w-full" severity="info"/>
                    <Button label="" @click='detail_page(merch.id, true)' size="small" icon="pi pi-external-link" text class="flex" severity="info"/>
                </div>
                <Button label="Редактировать" @click='edit(merch.user_id.toString())' outlined size="small" class="flex border-round-md" :disabled="loading" :loading="loading" severity="info"/>
            </div>
        </div>
    </div>

    <!--ИЗМЕНЕНИЕ-->
    <Dialog header="Редактировать мерчанта" class="flex flex-column border-none" modal
        v-model:visible="displayDialog" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '30vw'}" >
        
        <!--имя-->
        <div class="flex flex-row w-full mb-3" v-if="current_merchant && current_merchant.name != undefined">
            <span class="flex mr-2 mt-1">Мерчант: </span>
            <span class="flex text-700 text-xl font-medium white-space-nowrap">{{ current_merchant.name }}</span>
        </div>

        <!--Активность-->
        <div class="flex flex-column w-full mb-3" v-if="current_merchant && current_merchant.active_ != undefined">
            <span class="flex mb-2">Активность: </span>
            <SelectButton v-model="current_merchant.active_" :options="active_list" optionLabel="name" optionValue="value" aria-labelledby="basic" />
        </div>

        <!--Время работы-->
        <div class="flex flex-column">
            <span class="flex mb-2">Время работы (GMT): </span>
        </div>
        <div class="w-full flex flex-row mb-3">

            <div class="flex flex-column w-full pr-2" v-if="current_merchant && current_merchant.active_from_ != undefined">
                <Dropdown v-model="current_merchant.active_from_" :options="time_list" optionLabel="name" placeholder="Время работы ОТ" class="w-full flex" />
            </div>

            <div class="flex flex-column w-full" v-if="current_merchant && current_merchant.active_to_ != undefined">
                <Dropdown v-model="current_merchant.active_to_" :options="time_list" optionLabel="name" placeholder="Время работы ДО" class="w-full flex" />
            </div>
        </div>

        <div class="w-full flex flex-row mb-3 surface-100 p-2 border-round-lg">
            <span class="block">
                МСК +3 часа<br>
                Bali +8 часов
            </span><br>
        </div>

        <div class="w-full mb-3">
            <Button label="Изменить" @click='updMerchant()' :disabled="loading" :loading="loading"/>
        </div>

        <template #footer>
            <Button label="Закрыть" icon="pi pi-check" @click="closeDialog" autofocus severity="secondary" :disabled="loading" :loading="loading"/>
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    name: 'ListMerchant',
    props: {
        list: {
            type: [Array, Object],
            required: true
        },
    },
    data() {
        return {
            loading: false,
            displayDialog: false,
            current_merchant: {},
            active_list: [
                {name: 'Активен', value: true},
                {name: 'Не активен', value: false},
            ],
            time_list: [
                {name: 0, code: 0},
                {name: 1, code: 1},
                {name: 2, code: 2},
                {name: 3, code: 3},
                {name: 4, code: 4},
                {name: 5, code: 5},
                {name: 6, code: 6},
                {name: 7, code: 7},
                {name: 8, code: 8},
                {name: 9, code: 9},
                {name: 10, code: 10},
                {name: 11, code: 11},
                {name: 12, code: 12},
                {name: 13, code: 13},
                {name: 14, code: 14},
                {name: 15, code: 15},
                {name: 16, code: 16},
                {name: 17, code: 17},
                {name: 18, code: 18},
                {name: 19, code: 19},
                {name: 20, code: 20},
                {name: 21, code: 21},
                {name: 22, code: 22},
                {name: 23, code: 23},
                {name: 24, code: 24},
            ],
        }
    },
    methods: {
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
        get_msk_time(data){
            let time = data + 3
            if(time>24){
                time = time - 24
            }
            return time+':00'
        },
        get_local_time(data){
            let time = data + 8
            if(time>24){
                time = time - 24
            }
            return time+':00'
        },
        get_short_id(value){
            return this.helper.get_short_id(value)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        toTg(username){
            if(!username) return false
            const url = 'https://t.me/' + username
            window.open(url, '_blank')
        },
        goToUser(id){
            this.$router.push({ path: '/admin/user/' + id })
        },
        get_bank_title(code){
            return this.helper.get_bank_title(code, this.$store.state.payment.banks, this.lang_)
        },
        get_bank_image(code){
            return this.helper.get_bank_image(code, this.$store.state.payment.banks)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        detail_page(id, new_tab = false) {
            if(new_tab){
                const routeData = this.$router.resolve({path: '/admin/merchant/' + id});
                window.open(routeData.href, '_blank');
            } else  this.$router.push({ path: '/admin/merchant/' + id })
        },
        closeDialog(){
            this.displayDialog = false
            this.current_merchant = {}
        },
        edit(id){
            this.displayDialog = true
            this.current_merchant = this.getCurrentMerchantById(id)
            this.current_merchant.active_ = (this.current_merchant.active) ? true : false
            this.current_merchant.active_from_ = {name: this.current_merchant.active_from, code: this.current_merchant.active_from}
            this.current_merchant.active_to_ = {name: this.current_merchant.active_to, code: this.current_merchant.active_to}
        },
        getCurrentMerchantById(id){
            for (const key in this.list) {
                if (this.list[key].user_id.toString() === id.toString()) {
                    return Object.assign({}, this.list[key])
                }
            }
            return {}
        },
        async updMerchant(){
            this.loading = true
            if(!this.current_merchant.id || this.current_merchant.id == ''){
                this.showMess('warn', 'Внимание', 'Не указан ID мерчанта')
                return false
            }
            if(this.current_merchant.active_ === undefined){
                this.showMess('warn', 'Внимание', 'Не указана активность')
                return false
            }
            if(!this.current_merchant.active_from_ || this.current_merchant.active_from_.code == undefined){
                this.showMess('warn', 'Внимание', 'Не указано время работы ОТ')
                return false
            }
            if(!this.current_merchant.active_to_ || this.current_merchant.active_to_.code == undefined){
                this.showMess('warn', 'Внимание', 'Не указано время работы ДО')
                return false
            }
            const data = {
                id: this.current_merchant.id,
                active: this.current_merchant.active_,
                active_from: this.current_merchant.active_from_.code,
                active_to: this.current_merchant.active_to_.code,
            }
            const upd = await this.connect.UpdateMerchantByAdmin(data).then(res=>res)
            if(upd.result && upd.data){
                this.showMess('success', 'Успех', 'Мерчант изменен')
                this.displayDialog = false
                this.current_merchant = {}
                this.$emit('merchant_updated')
            }else{
                try{
                    for (let i = 0; i < upd.errors.length; i++) {
                        this.showMess('error', 'Ошибка', upd.errors[i])
                    }
                }catch(e){
                    this.showMess('error', 'Ошибка', 'Ошибка при изменении мерчанта')
                    console.log('error', e)
                }
            }
            this.loading = false
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>